/* =================================================================
   OS UI — Vanilla JS for the Jailbreak OS layer.
   Handles: cart toggle, view-mode switching, live clock, terminal.
   ================================================================= */

(function () {
  'use strict';

  /* ---- Interactive terminal ------------------------------------ */

  function initTerminal() {
    var terminal = document.getElementById('os-terminal');
    var output   = document.getElementById('os-terminal-output');
    var input    = document.getElementById('os-terminal-input');
    var typed    = document.getElementById('os-terminal-typed');
    if (!terminal || !output || !input || !typed) return;

    var prompt  = terminal.dataset.prompt || 'user@jailbreak:~$';
    var shopUrl = terminal.dataset.shopUrl || '/collections/all';
    var history = [];
    var histIdx = -1;

    function syncTyped() {
      typed.textContent = input.value;
    }

    function startSnakeGame(termEl) {
      var container = termEl.closest('.os-window') || termEl.parentElement;
      if (!container) return;
      var logoUrl = termEl.dataset.logoUrl || '';

      var overlay = document.createElement('div');
      overlay.className = 'os-snake-overlay';
      overlay.style.cssText = 'position:absolute;inset:0;background:#000;z-index:10;display:flex;flex-direction:column;';
      var scoreEl = document.createElement('div');
      scoreEl.style.cssText = 'color:#3dd68c;font-family:var(--os-font-mono,"Courier New",monospace);font-size:12px;padding:8px;flex-shrink:0;';
      overlay.appendChild(scoreEl);
      var canvas = document.createElement('canvas');
      canvas.style.cssText = 'flex:1;min-width:0;min-height:0;max-width:100%;image-rendering:pixelated;image-rendering:crisp-edges;';
      overlay.appendChild(canvas);
      var msgEl = document.createElement('div');
      msgEl.style.cssText = 'color:#fff;font-family:var(--os-font-mono,"Courier New",monospace);font-size:11px;padding:8px;text-align:center;flex-shrink:0;';
      overlay.appendChild(msgEl);

      container.style.position = 'relative';
      container.appendChild(overlay);

      var termInput = document.getElementById('os-terminal-input');
      if (termInput) {
        termInput.blur();
        termInput.setAttribute('tabindex', '-1');
      }
      overlay.setAttribute('tabindex', '0');
      overlay.focus();

      var COLS = 24, ROWS = 18;
      var cellW, cellH, gridW, gridH, offX, offY;
      var snake = [{ x: 5, y: Math.floor(ROWS / 2) }];
      var dir = { x: 1, y: 0 };
      var food = { x: 0, y: 0 };
      var score = 0;
      var running = true;
      var started = true;
      var lastTs = 0;
      var speed = 120;
      var logoImg = null;

      if (logoUrl) {
        logoImg = new Image();
        logoImg.onload = function () { if (typeof cellW === 'number') draw(); };
        logoImg.src = logoUrl;
      }

      function randFood() {
        do {
          food.x = Math.floor(Math.random() * COLS);
          food.y = Math.floor(Math.random() * ROWS);
        } while (snake.some(function(s) { return s.x === food.x && s.y === food.y; }));
      }

      function resize() {
        var r = container.getBoundingClientRect();
        var w = Math.max(200, r.width);
        var h = Math.max(150, r.height);
        cellW = Math.max(6, Math.floor(Math.min(w / COLS, h / ROWS)));
        cellH = cellW;
        gridW = cellW * COLS;
        gridH = cellH * ROWS;
        offX = (w - gridW) / 2;
        offY = (h - gridH) / 2;
        canvas.width = w;
        canvas.height = h;
        canvas.style.width = w + 'px';
        canvas.style.height = h + 'px';
      }

      function draw() {
        if (typeof cellW !== 'number' || cellW <= 0) return;
        var w = canvas.width || 400;
        var h = canvas.height || 300;
        var ctx = canvas.getContext('2d');
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, w, h);

        var px = offX, py = offY;
        ctx.strokeStyle = '#333';
        ctx.lineWidth = 1;
        ctx.strokeRect(px - 0.5, py - 0.5, gridW + 1, gridH + 1);

        ctx.fillStyle = '#3dd68c';
        for (var i = snake.length - 1; i > 0; i--) {
          var s = snake[i];
          var sx = px + s.x * cellW + 2;
          var sy = py + s.y * cellH + 2;
          ctx.fillRect(sx, sy, cellW - 4, cellH - 4);
        }

        var head = snake[0];
        var hx = px + head.x * cellW;
        var hy = py + head.y * cellH;
        ctx.fillStyle = '#3dd68c';
        ctx.fillRect(hx + 2, hy + 2, cellW - 4, cellH - 4);
        if (logoImg && logoImg.complete && logoImg.naturalWidth) {
          var headSize = cellW * 0.9;
          ctx.save();
          ctx.translate(hx + cellW / 2, hy + cellH / 2);
          var angle = dir.x === 1 ? 0 : dir.x === -1 ? Math.PI : dir.y === -1 ? -Math.PI / 2 : Math.PI / 2;
          ctx.rotate(angle);
          ctx.drawImage(logoImg, -headSize / 2, -headSize / 2, headSize, headSize);
          ctx.restore();
        }

        ctx.fillStyle = '#e63946';
        var fx = px + food.x * cellW + cellW / 2;
        var fy = py + food.y * cellH + cellH / 2;
        ctx.beginPath();
        if (cellW > 0) ctx.arc(fx, fy, Math.max(2, cellW / 3), 0, Math.PI * 2);
        ctx.fill();

        scoreEl.textContent = 'SCORE: ' + score;
        if (!started) msgEl.textContent = 'Press an arrow key to start';
        else msgEl.textContent = '';
      }

      function tick(ts) {
        if (!running || !started) return;
        if (ts - lastTs < speed) {
          requestAnimationFrame(tick);
          return;
        }
        lastTs = ts;

        var head = snake[0];
        var nx = head.x + dir.x;
        var ny = head.y + dir.y;
        if (nx < 0 || nx >= COLS || ny < 0 || ny >= ROWS) {
          gameOver();
          return;
        }
        if (snake.some(function(s) { return s.x === nx && s.y === ny; })) {
          gameOver();
          return;
        }
        snake.unshift({ x: nx, y: ny });
        if (nx === food.x && ny === food.y) {
          score++;
          speed = Math.max(60, speed - 3);
          randFood();
        } else {
          snake.pop();
        }
        draw();
        requestAnimationFrame(tick);
      }

      function gameOver() {
        running = false;
        msgEl.textContent = 'GAME OVER — Score: ' + score + '\nPress Enter to play again, Esc to exit';
        msgEl.style.whiteSpace = 'pre';
      }

      function handleKey(e) {
        var isGameKey = e.key === 'Escape' || e.key === 'Enter' ||
          e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowRight';
        if (!isGameKey) return;

        e.preventDefault();
        e.stopPropagation();

        if (e.key === 'Escape') {
          cleanup();
          return;
        }
        if (e.key === 'Enter' && !running) {
          snake = [{ x: 5, y: Math.floor(ROWS / 2) }];
          dir = { x: 1, y: 0 };
          score = 0;
          running = true;
          started = true;
          speed = 120;
          randFood();
          msgEl.textContent = '';
          lastTs = 0;
          requestAnimationFrame(tick);
          return;
        }
        if (!running) return;
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          if (!started) {
            started = true;
            msgEl.textContent = '';
            lastTs = 0;
            requestAnimationFrame(tick);
          }
          if (e.key === 'ArrowUp' && dir.y === 0) { dir.x = 0; dir.y = -1; }
          else if (e.key === 'ArrowDown' && dir.y === 0) { dir.x = 0; dir.y = 1; }
          else if (e.key === 'ArrowLeft' && dir.x === 0) { dir.x = -1; dir.y = 0; }
          else if (e.key === 'ArrowRight' && dir.x === 0) { dir.x = 1; dir.y = 0; }
        }
      }

      function cleanup() {
        overlay.removeEventListener('keydown', handleKey);
        document.removeEventListener('keydown', handleKey, true);
        window.removeEventListener('resize', resize);
        overlay.remove();
        if (termInput) {
          termInput.removeAttribute('tabindex');
          termInput.focus();
        }
      }

      overlay.addEventListener('click', function () { overlay.focus(); });
      overlay.addEventListener('keydown', handleKey);
      document.addEventListener('keydown', handleKey, true);
      window.addEventListener('resize', resize);
      randFood();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          resize();
          draw();
          lastTs = performance.now();
          requestAnimationFrame(tick);
        });
      });
    }

    var COMMANDS = {
      help: function () {
        return [
          'Available commands:',
          '',
          '  help             — Show this message',
          '  shop             — Browse the collection',
          '  cart             — Open shopping cart',
          '  stock            — Stock alerts signup',
          '  newsletter       — Newsletter signup',
          '  ls               — List site directories',
          '  cat             — ASCII art',
          '  cat README      — About Jailbreak',
          '  whoami           — Current user',
          '  date             — Current date/time',
          '  uptime           — System uptime',
          '  ping <host>      — Ping a server',
          '  neofetch         — System info',
          '  clear            — Clear terminal',
          '  snake            — Play Snake (Jailbreak style)',
          '',
          '  Hint: not all commands are listed...'
        ];
      },
      shop: function () {
        setTimeout(function () { window.location.href = shopUrl; }, 600);
        return ['[SYSTEM] Launching browser...', 'Navigating to ' + shopUrl];
      },
      browse: function () { return COMMANDS.shop(); },
      cart: function () {
        var cartEl = document.getElementById('os-cart-window');
        if (cartEl) {
          setTimeout(function () { cartEl.hidden = false; }, 300);
          return ['[SYSTEM] Opening SHOPPING_CART.SYS...'];
        }
        return ['[ERROR] Cart module not loaded.'];
      },
      stock: function () {
        var pageUrl = typeof window.__OS_NEWSLETTER_PAGE_URL === 'string' ? window.__OS_NEWSLETTER_PAGE_URL : '';
        if (pageUrl) {
          setTimeout(function () { window.location.href = pageUrl; }, 300);
          return ['[SYSTEM] Opening NEWSLETTER.URL...'];
        }
        var m = document.getElementById('os-info-modal-newsletter');
        if (m) {
          m.hidden = false;
          var win = m.querySelector('.os-info-modal__window');
          if (win) {
            win.style.left = Math.max(0, (window.innerWidth - win.offsetWidth) / 2) + 'px';
            win.style.top = Math.max(0, (window.innerHeight - win.offsetHeight) / 2) + 'px';
          }
          return ['[SYSTEM] Opening NEWSLETTER.TXT...'];
        }
        return ['[ERROR] Newsletter module not loaded.'];
      },
      newsletter: function () {
        return COMMANDS.stock();
      },
      ls: function () {
        return [
          'drwxr-xr-x  collections/',
          'drwxr-xr-x  products/',
          'drwxr-xr-x  cart/',
          '-rw-r--r--  README',
          '-rw-r--r--  LICENSE',
          '-rwx------  checkout.exe',
          '-rwx------  snake.exe'
        ];
      },
      dir: function () { return COMMANDS.ls(); },
      clear: function () {
        output.innerHTML = '';
        return [];
      },
      whoami: function () {
        return ['user001'];
      },
      date: function () {
        return [new Date().toString()];
      },
      uptime: function () {
        var s = Math.floor(performance.now() / 1000);
        var m = Math.floor(s / 60);
        s = s % 60;
        return ['up ' + m + ' min, ' + s + ' sec'];
      },
      ping: function (args) {
        var host = args[0] || 'localhost';
        return [
          'PING ' + host + ' (127.0.0.1) 56 bytes of data.',
          '64 bytes from ' + host + ': time=0.042ms',
          '64 bytes from ' + host + ': time=0.031ms',
          '--- ' + host + ' ping statistics ---',
          '2 packets transmitted, 2 received, 0% packet loss'
        ];
      },
      neofetch: function () {
        return [
          '       _  ____  ',
          '      | ||  _ \\ ',
          '      | || |_) |    OS: Jailbreak OS (Kernel 9.2.2)',
          '  _   | ||  _ <     Host: user001@jailbreak',
          ' | |__| || |_) |    Shell: jb-sh 1.0',
          '  \\____/ |____/     Resolution: ' + window.innerWidth + 'x' + window.innerHeight,
          '                    Theme: Platinum [Dark Terminal]'
        ];
      },
      'cat': function (args) {
        if (args[0] && args[0].toLowerCase() === 'readme') {
          return [
            '# JAILBREAK',
            '',
            'Streetwear for the system override generation.',
            'Every piece is a crack in the firewall.',
            '',
            'Est. 2026 — All rights breached.'
          ];
        }
        if (!args[0]) {
          var hero = document.querySelector('.os-hero');
          var catLines = [
            { text: ' |`-.._____..-\'|', css: 'os-terminal__art-cat' },
            { text: ' :  > .  ,  <  :', css: 'os-terminal__art-cat' },
            { text: ' `./ __`\' __ \\,\'', css: 'os-terminal__art-cat' },
            { text: '  | (|_) (|_) |', css: 'os-terminal__art-cat' },
            { text: '  ; _  .  __  :', css: 'os-terminal__art-cat' },
            { text: '  `.,\' - `-. ,\'', css: 'os-terminal__art-cat' },
            { text: '    `, `_  .\'', css: 'os-terminal__art-cat' },
            { text: '    /       \\', css: 'os-terminal__art-cat' },
            { text: '   /         :', css: 'os-terminal__art-cat' },
            { text: '  :          |_', css: 'os-terminal__art-cat' },
            { text: ' ,|  .    .  | \\', css: 'os-terminal__art-cat' },
            { text: ': :   \\   |  |  :', css: 'os-terminal__art-cat' },
            { text: '|  \\   :`-;  ;  |', css: 'os-terminal__art-cat' },
            { text: ':   :  | /  /   ;', css: 'os-terminal__art-cat' },
            { text: ' :-.\'  ;\'  / _,\'`------.', css: 'os-terminal__art-cat' },
            { text: "              `'`''-`'''-'-''--.---  )", css: 'os-terminal__art-cat' },
            { text: '------------------------------------------------', css: 'os-terminal__art-cat' }
          ];
          var steps = [
            { fn: function () { if (hero) hero.classList.add('os-hero--expanded'); }, delay: 300 },
            { pause: 400 },
            { text: '', delay: 0 }
          ];
          catLines.forEach(function (line) {
            steps.push({ text: line.text, css: line.css, delay: 25 });
          });
          typeSequence(steps);
          return [];
        }
        return ['cat: ' + args[0] + ': No such file or directory'];
      },
      sudo: function () {
        return ['[DENIED] Nice try.'];
      },
      rm: function () {
        return ['[DENIED] Permission denied. Cannot delete system files.'];
      },
      exit: function () {
        return ['[SYSTEM] There is no escape from Jailbreak.'];
      },
      snake: function () {
        appendLines(['[SYSTEM] Launching SNAKE.EXE...', 'Arrow keys to move. Esc to exit.'], 'os-terminal__muted');
        setTimeout(function () { startSnakeGame(terminal); }, 400);
        return [];
      },
      jailbreak_now: function () {
        var hero = document.querySelector('.os-hero');
        typeSequence([
          { text: '[OVERRIDE] Initiating system jailbreak...', css: 'os-terminal__accent', delay: 80 },
          { pause: 400 },
          { text: '[▓░░░░░░░░░] 8%  — Bypassing firewall...', css: 'os-terminal__muted', delay: 300 },
          { text: '[▓▓▓░░░░░░░] 24% — Cracking encryption layer...', css: 'os-terminal__muted', delay: 350 },
          { text: '[▓▓▓▓▓░░░░░] 47% — Injecting style payload...', css: 'os-terminal__muted', delay: 300 },
          { text: '[▓▓▓▓▓▓▓░░░] 68% — Overriding dress code...', css: 'os-terminal__muted', delay: 250 },
          { text: '[▓▓▓▓▓▓▓▓▓░] 91% — Deploying swag protocol...', css: 'os-terminal__muted', delay: 300 },
          { text: '[▓▓▓▓▓▓▓▓▓▓] 100% — COMPLETE', css: 'os-terminal__green', delay: 100 },
          { pause: 500 },
          { fn: function() { if (hero) hero.classList.add('os-hero--expanded'); }, delay: 300 },
          { text: '', delay: 50 },
          { text: '                                         PROJECT JAILBREAK\u00AE', css: 'os-terminal__art', delay: 40 },
          { text: '                                           By joost klein', css: 'os-terminal__art', delay: 40 },
          { text: '', delay: 30 },
          { text: '                                                          @@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                                     @@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                                   @@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                                 @@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                                @@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                                @@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                               @@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                               @@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                  @@@@@@@@@             @@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                             @@@@@@@@@@@@@@@@@@@ @@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                           @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                         @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                        @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                       @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                      @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                     @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                     @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                     @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                     @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                      @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                      @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                       @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                        @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                         @@@@@@@    @@@@@@@@@@@@@@@@@@@@@@@@@@@   @@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                         @@@@@@         @@@@@@@@@@@@@@@@@@          @@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                          @@@@@@            @@@@@@@@@@@             @@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                          @@@@@@          @@@@@@@@@@@@@@           @@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                         @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                         @@@@@@@@@@@@@@@@@@@@@@ @@@ @@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                           @@@@@@@@@@@@@@@@@@@  @@@ @@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                             @@@@@@@@@@@@@@@@@  @@@ @@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                      @@@@@     @     @@@@@@@@@@@@@@@@@@@@@@@     @      @@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                     @@@@@@@          @@@@@@@@@@@@@@@@@@@@@@            @@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                    @@@@@@@@@         @@@@@@@@@@@@@@@@@@@@@@           @@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                   @@@@@@@@@@@@        @@@@ @@@@@@@@@@@ @@@@         @@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                 @@@@@@@@@@@@@@@@@           @@@  @@@@            @@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                 @@@@@@@@@@@@@@@@@@@@@                         @@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                 @@@@@@@@@@@@@@@@@@@@@@@@@@              @@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                              @@@@@@@@@@@@@@@@@      @@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                       @@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                         @@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                     @@@@@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                 @@@@@@@@@@@@@@@@  @@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                     @@@@@@@@@@@@@@@@@@@@@@@            @@@@@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                    @@@@@@@@@@@@@@@@@@@@@                   @@@@@@@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                     @@@@@@@@@@@@@@@@                           @@@@@@@@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                        @@@@@@@@@@                                 @@@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                        @@@@@@@@@      this is NOT a virus haha     @@@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                         @@@@@@@                                    @@@@@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                          @@@@          thank you for trusting        @@@@', css: 'os-terminal__art', delay: 25 },
          { text: '                                              the process', css: 'os-terminal__art', delay: 25 },
          { text: '', delay: 50 },
          { pause: 300 },
          { text: '  ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░', css: 'os-terminal__muted', delay: 30 },
          { text: '  STATUS: SYSTEM BREACHED', css: 'os-terminal__green', delay: 80 },
          { text: '  ACCESS: ROOT GRANTED', css: 'os-terminal__green', delay: 80 },
          { text: '  DRESS CODE: OVERRIDDEN', css: 'os-terminal__green', delay: 80 },
          { text: '  SWAG LEVEL: ████████████████ MAX', css: 'os-terminal__accent', delay: 80 },
          { text: '  ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░', css: 'os-terminal__muted', delay: 30 },
          { text: '', delay: 50 },
          { pause: 400 },
          { text: '  Welcome to the other side.', css: 'os-terminal__white', delay: 100 },
          { text: '  The system is yours. Wear it.', css: 'os-terminal__white', delay: 100 },
          { text: '', delay: 50 },
          { text: '  → Type "shop" to claim your gear.', css: 'os-terminal__green', delay: 80 }
        ]);
        return [];
      }
    };

    var locked = false;

    function appendLine(text, cssClass) {
      var p = document.createElement('p');
      p.className = cssClass || 'os-terminal__white';
      p.style.whiteSpace = 'pre';
      p.textContent = text;
      output.appendChild(p);
      terminal.scrollTop = terminal.scrollHeight;
      return p;
    }

    function appendLines(lines, cssClass) {
      lines.forEach(function (line) {
        appendLine(line, cssClass);
      });
    }

    function typeSequence(steps, done) {
      locked = true;
      var i = 0;
      function next() {
        if (i >= steps.length) {
          locked = false;
          if (done) done();
          return;
        }
        var step = steps[i];
        i++;
        if (step.fn) {
          step.fn();
          setTimeout(next, step.delay || 0);
        } else if (step.pause) {
          setTimeout(next, step.pause);
        } else {
          appendLine(step.text || '', step.css || 'os-terminal__muted');
          setTimeout(next, step.delay || 60);
        }
      }
      next();
    }

    function echoPrompt(trimmed) {
      appendLine(prompt + ' ' + trimmed, 'os-terminal__white');
    }

    function processCommand(raw) {
      var trimmed = raw.trim();
      if (!trimmed) {
        echoPrompt('');
        return;
      }
      if (locked) return;

      history.unshift(trimmed);
      histIdx = -1;

      echoPrompt(trimmed);

      var parts = trimmed.split(/\s+/);
      var cmd   = parts[0].toLowerCase();
      var args  = parts.slice(1);

      if (cmd === 'jailbreak_now') {
        COMMANDS.jailbreak_now(args);
        return;
      }
      if (cmd === 'cat' && args.length === 0) {
        COMMANDS.cat(args);
        return;
      }

      var handler = COMMANDS[cmd];
      if (handler) {
        var result = handler(args);
        if (result.length > 0) {
          appendLines(result, 'os-terminal__muted');
        }
      } else {
        appendLines(
          ['jb-sh: command not found: ' + cmd, 'Type "help" for available commands.'],
          'os-terminal__muted'
        );
      }

      terminal.scrollTop = terminal.scrollHeight;
    }

    input.addEventListener('input', syncTyped);

    input.addEventListener('keydown', function (e) {
      if (locked) { e.preventDefault(); return; }
      if (e.key === 'Enter') {
        processCommand(input.value);
        input.value = '';
        syncTyped();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (history.length > 0 && histIdx < history.length - 1) {
          histIdx++;
          input.value = history[histIdx];
          syncTyped();
        }
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (histIdx > 0) {
          histIdx--;
          input.value = history[histIdx];
          syncTyped();
        } else {
          histIdx = -1;
          input.value = '';
          syncTyped();
        }
      } else if (e.key === 'Tab') {
        e.preventDefault();
        var val = input.value.toLowerCase();
        var cmds = Object.keys(COMMANDS);
        for (var ci = 0; ci < cmds.length; ci++) {
          if (cmds[ci].indexOf(val) === 0 && val.length > 0) {
            input.value = cmds[ci];
            syncTyped();
            break;
          }
        }
      } else if (e.ctrlKey && e.key === 'l') {
        e.preventDefault();
        COMMANDS.clear();
      } else if (e.ctrlKey && e.key === 'c') {
        e.preventDefault();
        appendLine(prompt + ' ' + input.value + '^C', 'os-terminal__muted');
        input.value = '';
        syncTyped();
      }
    });

    terminal.addEventListener('click', function () {
      input.focus();
    });

    input.focus();
  }

  /* ---- Cart toggle --------------------------------------------- */

  function initCartToggle() {
    var cart = document.getElementById('os-cart-window');
    if (!cart) return;

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-os-cart-toggle]');
      if (toggle) {
        e.preventDefault();
        cart.hidden = !cart.hidden;
        return;
      }

      /* Minimize button inside cart */
      var minimize = e.target.closest('.os-ctrl--minimize');
      if (minimize && cart.contains(minimize)) {
        e.preventDefault();
        cart.hidden = true;
        return;
      }

      /* Close on click outside */
      if (!cart.hidden && !cart.contains(e.target)) {
        cart.hidden = true;
      }
    });

    /* Close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !cart.hidden) {
        cart.hidden = true;
      }
    });
  }

  /* ---- View-mode switcher -------------------------------------- */

  var VIEW_KEY = 'os-view-mode';
  var MODES = ['view-icon', 'view-list'];

  function setViewMode(mode) {
    if (MODES.indexOf(mode) === -1) mode = MODES[0];

    MODES.forEach(function (m) {
      document.body.classList.toggle(m, m === mode);
    });

    /* Update active button states */
    document.querySelectorAll('[data-os-view]').forEach(function (btn) {
      btn.classList.toggle('os-btn--active', btn.dataset.osView === mode);
    });

    try { localStorage.setItem(VIEW_KEY, mode); } catch (e) { /* noop */ }
  }

  function initViewSwitcher() {
    /* Restore saved preference */
    var saved = null;
    try { saved = localStorage.getItem(VIEW_KEY); } catch (e) { /* noop */ }
    setViewMode(saved || MODES[0]);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-os-view]');
      if (btn) {
        e.preventDefault();
        setViewMode(btn.dataset.osView);
      }
    });
  }

  /* ---- Live clock ---------------------------------------------- */

  function initClock() {
    var el = document.getElementById('os-clock');
    if (!el) return;

    var hNode = document.createTextNode('');
    var sep = document.createElement('span');
    sep.className = 'os-blink';
    sep.textContent = ':';
    var mNode = document.createTextNode('');
    var amNode = document.createTextNode('');
    el.textContent = '';
    el.appendChild(hNode);
    el.appendChild(sep);
    el.appendChild(mNode);
    el.appendChild(amNode);

    var lastH = '', lastM = '';
    function tick() {
      var now = new Date();
      var h = now.getHours();
      var ampm = h >= 12 ? ' PM' : ' AM';
      h = h % 12 || 12;
      var m = now.getMinutes();
      m = m < 10 ? '0' + m : '' + m;
      h = '' + h;
      if (h !== lastH) { hNode.textContent = h; lastH = h; }
      if (m !== lastM) { mNode.textContent = m; amNode.textContent = ampm; lastM = m; }
    }

    tick();
    setInterval(tick, 15000);
  }

  /* ---- AJAX add-to-cart ---------------------------------------- */

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderOsCart(cart) {
    var body = document.querySelector('[data-os-cart-body]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="os-cart__empty">Your cart is empty.</p>';
      return;
    }

    var html = '<div class="os-cart__items">';
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      html += '<div class="os-cart__line">'
            + '<span class="os-cart__line-title">' + item.product_title.toUpperCase() + ' x ' + item.quantity + '</span>'
            + '<span class="os-cart__line-price">' + formatMoney(item.final_line_price) + '</span>'
            + '</div>';
    }
    html += '</div>';

    html += '<div class="os-cart__subtotal">'
          + '<span class="os-cart__subtotal-label">SUBTOTAL_</span>'
          + '<span class="os-cart__subtotal-value">' + formatMoney(cart.total_price) + '</span>'
          + '</div>';

    html += '<div class="os-cart__buttons">'
          + '<a href="/cart" class="os-btn os-cart__view-cart">View Cart</a>'
          + '<a href="/checkout" class="os-btn os-cart__checkout">Checkout</a>'
          + '</div>';

    html += '<p class="os-cart__secure">Secure Connection Est.</p>';

    body.innerHTML = html;
  }

  function updateCartBadge(count) {
    var span = document.querySelector('[data-os-cart-count]');
    if (span) span.textContent = count;
  }

  function initAjaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('#os-product-form');
      if (!form) return;

      e.preventDefault();

      var btn = form.querySelector('.os-pdp__atc');
      if (btn) {
        btn.setAttribute('disabled', '');
        btn.textContent = 'Adding...';
      }

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function (res) { return res.json(); })
      .then(function (addResponse) {
        if (addResponse.status) {
          if (btn) {
            btn.removeAttribute('disabled');
            btn.textContent = 'ERROR: ' + (addResponse.description || 'FAILED');
          }
          setTimeout(function () {
            if (btn) btn.textContent = 'Add to Cart';
          }, 3000);
          return;
        }

        return fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            renderOsCart(cart);
            updateCartBadge(cart.item_count);
            batteryCharge(battery.CHARGE_AMOUNT);

            var cartEl = document.getElementById('os-cart-window');
            if (cartEl) cartEl.hidden = false;

            if (btn) {
              btn.removeAttribute('disabled');
              btn.textContent = 'Added ✓';
            }
            setTimeout(function () {
              if (btn) btn.textContent = 'Add to Cart';
            }, 2000);
          });
      })
      .catch(function () {
        if (btn) {
          btn.removeAttribute('disabled');
          btn.textContent = 'Add to Cart';
        }
      });
    });
  }

  /* ---- Shop dropdown --------------------------------------------- */

  function initShopDropdown() {
    var toggle = document.getElementById('os-shop-toggle');
    var panel  = document.getElementById('os-shop-panel');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = panel.classList.toggle('is-visible');
      toggle.classList.toggle('is-open', open);

      var infoPanel = document.getElementById('os-info-panel');
      var infoToggle = document.getElementById('os-info-toggle');
      if (infoPanel) infoPanel.classList.remove('is-visible');
      if (infoToggle) infoToggle.classList.remove('is-open');
    });

    document.addEventListener('click', function(e) {
      if (!panel.classList.contains('is-visible')) return;
      if (!e.target.closest('#os-shop-dropdown')) {
        panel.classList.remove('is-visible');
        toggle.classList.remove('is-open');
      }
    });
  }

  /* ---- WiFi dropdown --------------------------------------------- */

  function initWifiDropdown() {
    var toggle = document.getElementById('os-wifi-toggle');
    var panel  = document.getElementById('os-wifi-panel');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = panel.classList.toggle('is-visible');
      toggle.classList.toggle('is-open', open);
    });

    document.addEventListener('click', function(e) {
      if (!panel.classList.contains('is-visible')) return;
      if (!e.target.closest('#os-wifi-dropdown')) {
        panel.classList.remove('is-visible');
        toggle.classList.remove('is-open');
      }
    });
  }

  /* ---- Battery -------------------------------------------------- */

  var battery = {
    level: 100,
    MIN_WIDTH: 1,
    MAX_WIDTH: 13,
    DRAIN_INTERVAL: 8000,
    DRAIN_AMOUNT: 1,
    CHARGE_AMOUNT: 12,
    el: null,
    fill: null,
    warn: null,
    _timer: null,
    _chargeTimeout: null,
    _warnTimeout: null,
    _warnShown: false
  };

  function batterySetLevel(pct) {
    battery.level = Math.max(0, Math.min(100, pct));
    if (!battery.fill || !battery.el) return;
    var w = battery.MIN_WIDTH + (battery.MAX_WIDTH - battery.MIN_WIDTH) * (battery.level / 100);
    battery.fill.setAttribute('width', w.toFixed(1));

    var isWarn = battery.level <= 45 && battery.level > 20;
    var isLow = battery.level <= 20 && battery.level > 10;
    var isCritical = battery.level <= 10;

    battery.el.classList.toggle('is-warn', isWarn);
    battery.el.classList.toggle('is-low', isLow);
    battery.el.classList.toggle('is-critical', isCritical);

    if (battery.warn) {
      if ((isLow || isCritical) && !battery._warnShown) {
        battery._warnShown = true;
        battery.warn.classList.add('is-visible');
        clearTimeout(battery._warnTimeout);
        battery._warnTimeout = setTimeout(function () {
          if (battery.warn) battery.warn.classList.remove('is-visible');
        }, 4000);
      }
      if (battery.level > 20) {
        battery._warnShown = false;
        battery.warn.classList.remove('is-visible');
      }
    }
  }

  function batteryCharge(amount) {
    if (!battery.el) return;
    battery.el.classList.remove('is-warn', 'is-low', 'is-critical');
    battery.el.classList.add('is-charging');
    batterySetLevel(battery.level + (amount || battery.CHARGE_AMOUNT));

    if (battery.warn) battery.warn.classList.remove('is-visible');

    clearTimeout(battery._chargeTimeout);
    battery._chargeTimeout = setTimeout(function () {
      if (battery.el) battery.el.classList.remove('is-charging');
    }, 2000);
  }

  function initBattery() {
    battery.el = document.getElementById('os-battery');
    battery.fill = document.getElementById('os-battery-fill');
    battery.warn = document.getElementById('os-battery-warn');
    if (!battery.el || !battery.fill) return;

    batterySetLevel(100);

    battery._timer = setInterval(function () {
      batterySetLevel(battery.level - battery.DRAIN_AMOUNT);
    }, battery.DRAIN_INTERVAL);

    document.addEventListener('click', function (e) {
      if (e.target.closest('a[href*="/products/"]') || e.target.closest('.os-card')) {
        batteryCharge(8);
      } else if (e.target.closest('button, .os-btn, [type="submit"], a.os-header__nav a, .os-header__dropdown-item')) {
        batteryCharge(3);
      }
    });

    var scrollDrain = 0;
    var scrollQueued = false;
    window.addEventListener('scroll', function () {
      if (scrollQueued) return;
      scrollQueued = true;
      requestAnimationFrame(function () {
        scrollQueued = false;
        scrollDrain++;
        if (scrollDrain >= 8) {
          batterySetLevel(battery.level - 1);
          scrollDrain = 0;
        }
      });
    }, { passive: true });

    var moveDrain = 0;
    var moveQueued = false;
    document.addEventListener('mousemove', function () {
      if (moveQueued) return;
      moveQueued = true;
      requestAnimationFrame(function () {
        moveQueued = false;
        moveDrain++;
        if (moveDrain >= 40) {
          batterySetLevel(battery.level - 1);
          moveDrain = 0;
        }
      });
    }, { passive: true });
  }

  /* ---- Boot ---------------------------------------------------- */

  function boot() {
    document.body.classList.add('os-theme');
    initTerminal();
    initCartToggle();
    initViewSwitcher();
    initClock();
    initAjaxCart();
    initShopDropdown();
    initWifiDropdown();
    initBattery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
